module.exports = __webpack_public_path__ + "static/media/Eclipton_Pitch_Deck.a28e4dca.pdf";